import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Modal, useModalContext, Button, Box, TextBody, Space, muiBankTheme, } from '@ally/metronome-ui';
var ServiceDownModalContent = function (_a) {
    var closeModal = _a.closeModal;
    return (React.createElement(ThemeProvider, { theme: muiBankTheme },
        React.createElement(Box, { display: "flex", flexDirection: "column" },
            React.createElement(Box, { display: "flex", mb: "sm" },
                React.createElement(TextBody, { size: "lg", tag: "p" }, "This service isn't available right now, but we're working on it.")),
            React.createElement(Box, null,
                React.createElement(TextBody, { size: "sm", tag: "p" }, "We're working to have things back up as soon as possible. Try again later.")),
            React.createElement(Space, { mt: "sm" },
                React.createElement(Button, { variant: "primary", content: "Close", onClick: function () { return closeModal(); } })))));
};
var useServiceDownModal = function () {
    var context = useModalContext();
    var showModal = context.showModal, closeModal = context.closeModal;
    var ServiceDownModal = function () { return (React.createElement(Modal, { content: React.createElement(ServiceDownModalContent, { closeModal: closeModal }), context: context })); };
    return { showModal: showModal, ServiceDownModal: ServiceDownModal };
};
export { ServiceDownModalContent, useServiceDownModal };
//# sourceMappingURL=ServiceDownModal.js.map